<template>

    <transition name="modal">
        <div class="td-app-loader" v-show="isVisible">
            <div class="td-app-loader-wrapper">
                <div class="td-app-loader-container">
                    <progress-bar :progress="currentProgress"></progress-bar>
                    <div class="progress-bar-text">
                        {{$__('Loading')}}<span class="loader__dot">.</span><span class="loader__dot">.</span><span class="loader__dot">.</span>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    import Vue from 'vue';
    import progressBar from './components/progressBar.vue';



    window.EventBus = new Vue();

    export default {
        props: {
            extraTopMargin: {
                type: Number
            }
        },
        data() {
            return {
                isVisible: false,
                appLoaderShowRoute: '',
                showCounter: 0,
                hideCounter: 0,

                progressTickHandler:null,
                progressTickStep: 30,
                progressTickCount: 0,
                currentProgress: 0


            }
        },
        created() {
            let vm = this;

            // appLoader_show - show the progressbar (skip if it's already shown)
            window.EventBus.$on('appLoader_show_once', function() {

                if (vm.progressTickHandler !== null) {
                    return;
                }

                vm.progressTickHandler = setInterval(function(){
                    //console.log("PROGRESS TICK -------------");


                    let nextProgressStep = vm.currentProgress + vm.progressTickStep;

                    //console.log(vm.currentProgress);
                    // stop at 90
                    if (nextProgressStep >= 90) {
                        clearTimeout(vm.progressTickHandler);
                        vm.progressTickHandler = null;
                        vm.currentProgress = 90;
                    } else {
                        vm.currentProgress = vm.currentProgress + vm.progressTickStep;
                    }
                    vm.progressTickStep = vm.getRandomInt(7,19);




                }, 500);

                vm.showCounter++;

                // on what route it was shown
                vm.appLoaderShowRoute = vm.$route.name;
                vm.isVisible = true;

            });


            // appLoader_show - show the progressbar
            window.EventBus.$on('appLoader_show', function() {
                clearTimeout(vm.progressTickHandler);
                vm.progressTickHandler = null;
                vm.resetProgressBar();
                //console.log("PROGRESS START -------------");

                vm.progressTickHandler = setInterval(function(){
                    //console.log("PROGRESS TICK -------------");


                    let nextProgressStep = vm.currentProgress + vm.progressTickStep;

                    //console.log(vm.currentProgress);
                    // stop at 90
                    if (nextProgressStep >= 90) {
                        clearTimeout(vm.progressTickHandler);
                        vm.progressTickHandler = null;
                        vm.currentProgress = 90;
                    } else {
                        vm.currentProgress = vm.currentProgress + vm.progressTickStep;
                    }
                    vm.progressTickStep = vm.getRandomInt(7,19);




                }, 500);

                vm.showCounter++;

                // on what route it was shown
                vm.appLoaderShowRoute = vm.$route.name;
                vm.isVisible = true;

            });


            window.EventBus.$on('appLoader_hide', function() {
                //return;
                //console.log('appLoader_hide called', JSON.parse(JSON.stringify(vm.showCounter)), JSON.parse(JSON.stringify(vm.showCounter)));
                //return;
                vm.hideCounter++;

                // use to deal with concurrency issues, when a request replies later and sends a close event but the request is oooold and invalid (ex user navigated away)
                if (vm.showCounter <= vm.hideCounter) {
                    //console.log('hideLoader', JSON.parse(JSON.stringify(vm.showCounter)), JSON.parse(JSON.stringify(vm.showCounter)));

                    vm.showCounter = 0;
                    vm.hideCounter = 0;

                    vm.hideLoader(true);
                } else {
                    //console.log ("SKIP HIDE EVENT ON LOADER");
                }


            });

        },

        methods: {
            hideLoader(goTo100Percent) {
                let vm = this;
                let resetProgressBarTimeout = 310; // reset the progressbar only after the fade 0.3s animation is finish

                // clear the timeout immediately
                vm.appLoaderShowRoute = '';
                clearTimeout(vm.progressTickHandler);
                vm.progressTickHandler = null;


                if (goTo100Percent === true) {
                    vm.currentProgress = 100;
                    resetProgressBarTimeout = 410;
                    setTimeout(function () {
                        //return;
                        vm.isVisible = false;
                    }, 100);

                } else {
                    vm.isVisible = false;
                }

                // wait for the hide animation to finish
                setTimeout(function() {
                    vm.resetProgressBar();
                }, resetProgressBarTimeout);
            },

            resetProgressBar() {
                let vm = this;

                vm.currentProgress = 0;
                vm.progressTickStep = 30;
                vm.progressTickCount = 0;

            },

            getRandomInt(min, max) {
                min = Math.ceil(min);
                max = Math.floor(max);
                return Math.floor(Math.random() * (max - min)) + min; //The maximum is exclusive and the minimum is inclusive
            }


        },
        watch: {
            '$route' (to, from) {
                let vm = this;



                // deal with route changes
                if (vm.appLoaderShowRoute !== '' && to.name !== vm.appLoaderShowRoute) {
                    // back button was hit
                    console.log('<<<---- BACK hideLoader called');
                    this.hideLoader();
                }



             }
        },
        components: {

            'progress-bar':progressBar
        },
    }

</script>


<style lang="scss">
    .td-app-loader {
        position: fixed;
        z-index: 99998;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        //background-color: rgba(255, 255, 255, 0.7);
        transition: opacity .3s ease;
        display: block;



        .td-app-loader-wrapper {
            display: block;
            vertical-align: auto;
            top: 50%;
            position: relative;
            transform: translateY(-50%);
        }

        .td-app-loader-container {
            position: relative;
            width: 600px;
            max-height: 95vh;
            margin: 0 auto;
            padding: 15px;
            -webkit-overflow-scrolling: touch;
            background-color: #fff;
            border-radius: 4px;
            box-shadow: 0 10px 70px 0 rgba(67,120,180,.22), 0 15px 105px 0 rgba(67,120,180,.22);

            //border: 1px solid #bad2ee;
            transition: all 0.2s ease;
            font-family: 'Open Sans', Arial, sans-serif;

            @media (max-width: 767px) {
                width: 95%;
            }
            overflow: visible;
            //scrollbar-width: thin;
            display: flex;
            flex-direction: column;

            /* FIX  - IOS Safari auto zoom-in*/
            select,
            textarea,
            input[type="text"],
            input[type="password"],
            input[type="datetime"],
            input[type="datetime-local"],
            input[type="date"],
            input[type="month"],
            input[type="time"],
            input[type="week"],
            input[type="number"],
            input[type="email"],
            input[type="url"],
            input[type="search"],
            input[type="tel"],
            input[type="color"] {
                font-size: 13px;
            }
        }


        .td-is-mobile {
            .td-app-loader-wrapper {
                top:auto;
                -webkit-transform: translateY(0);
                transform: translateY(0);
            }

            .td-app-loader-container {
                max-height: 82vh;
            }

        }




        .progress {
            height: 8px;
            margin: 20px 0 5px 0;
            border-radius: 20px;
        }
        .progress-bar {
            background-color: #395fc5;
            border-top: 1px solid #3355b1;
            border-bottom: 1px solid #3355b1;
        }

        .progress-bar-text {
            color: #616060;
            font-size:12px;
        }

        @keyframes blink {50% { color: transparent }}
        .loader__dot { animation: 1s blink infinite }
        .loader__dot:nth-child(2) { animation-delay: 250ms }
        .loader__dot:nth-child(3) { animation-delay: 500ms }

    }



</style>



// WEBPACK FOOTER //
// src/components/appLoader/appLoader.vue